import { defineStore } from 'pinia'

const STORAGE_KEY = 'pavemi_theme'
const VALID = ['light', 'dark', 'system']

function systemPrefersDark() {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
}

function resolvedMode(mode) {
  if (mode === 'system') return systemPrefersDark() ? 'dark' : 'light'
  return mode
}

function applyToDom(mode) {
  const isDark = resolvedMode(mode) === 'dark'
  document.documentElement.classList.toggle('dark', isDark)
}

export const useThemeStore = defineStore('theme', {
  state: () => {
    const stored = localStorage.getItem(STORAGE_KEY)
    const mode = VALID.includes(stored) ? stored : 'system'
    return { mode }
  },

  getters: {
    isDark: (state) => resolvedMode(state.mode) === 'dark',
  },

  actions: {
    init() {
      applyToDom(this.mode)

      if (window.matchMedia) {
        const mq = window.matchMedia('(prefers-color-scheme: dark)')
        mq.addEventListener('change', () => {
          if (this.mode === 'system') applyToDom('system')
        })
      }
    },

    set(mode) {
      if (!VALID.includes(mode)) return
      this.mode = mode
      localStorage.setItem(STORAGE_KEY, mode)
      applyToDom(mode)
    },

    toggle() {
      this.set(this.isDark ? 'light' : 'dark')
    },
  },
})
